import React from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';

interface SuccessAnimationProps {
	visible: boolean;
}

const SuccessAnimation: React.FC<SuccessAnimationProps> = ({ visible }) => {
	if (!visible) {
		return null;
	}

	return (
		<div className="w-full h-full flex flex-col items-center justify-center py-12 relative overflow-hidden">
			<div className="relative z-10 text-center">
				<div className="relative mb-6">
					<div className="w-20 h-20 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center mx-auto animate-pulse shadow-lg">
						<CheckCircleOutlined className="text-4xl text-white" />
					</div>
					<div className="absolute -top-2 -right-2 w-8 h-8 bg-green-300 rounded-full animate-ping opacity-75" />
				</div>

				<h3 className="text-2xl font-bold text-gray-800 mb-3">
					🎉 Outbound Task Created Successfully!
				</h3>
				<p className="text-gray-600 mb-6 text-base max-w-md mx-auto">
					Your outbound task has been created and is ready to launch. You can now start reaching out
					to your prospects!
				</p>

				<div className="flex space-x-2 justify-center mb-4">
					{[...Array(5)].map((_, i) => (
						<div
							key={i}
							className="w-2 h-2 bg-green-500 rounded-full animate-bounce"
							style={{ animationDelay: `${i * 0.1}s` }}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

export default SuccessAnimation;
